import React, { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import AppContext from '../context/AppContext';

const ADMIN_USER = 'admin';
const ADMIN_PASS = 'minutos123';

export default function Admin() {
  const { linkSite, setLinkSite } = useContext(AppContext);
  const [autenticado, setAutenticado] = useState(false);
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [novoLink, setNovoLink] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [sucesso, setSucesso] = useState(false);

  const handleLogin = () => {
    if (usuario === ADMIN_USER && senha === ADMIN_PASS) {
      setNovoLink(linkSite);
      setAutenticado(true);
      setErro('');
    } else {
      setErro('Usuário ou senha incorretos.');
    }
  };

  const handleSalvar = async () => {
    if (!novoLink.trim()) return;
    setSalvando(true);
    setSucesso(false);
    setErro('');
    try {
      const res = await fetch('/salvar.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ meuLink: novoLink.trim() }),
      });
      if (res.ok) {
        setLinkSite(novoLink.trim());
        setSucesso(true);
      } else {
        setErro('Erro ao salvar no servidor.');
      }
    } catch {
      setErro('Erro de conexão com o servidor.');
    } finally {
      setSalvando(false);
    }
  };

  if (!autenticado) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="bg-gray-900 p-8 rounded-lg w-full max-w-sm flex flex-col gap-4">
          <h1 className="text-white text-xl font-bold text-center">Acesso Admin</h1>
          <TextField
            label="Usuário"
            value={ usuario }
            onChange={ (e) => setUsuario(e.target.value) }
            fullWidth
            size="small"
            InputLabelProps={{ style: { color: '#aaa' } }}
            InputProps={{ style: { color: '#fff' } }}
            sx={{ '& .MuiOutlinedInput-root fieldset': { borderColor: '#555' } }}
          />
          <TextField
            label="Senha"
            type="password"
            value={ senha }
            onChange={ (e) => setSenha(e.target.value) }
            fullWidth
            size="small"
            InputLabelProps={{ style: { color: '#aaa' } }}
            InputProps={{ style: { color: '#fff' } }}
            sx={{ '& .MuiOutlinedInput-root fieldset': { borderColor: '#555' } }}
            onKeyDown={ (e) => e.key === 'Enter' && handleLogin() }
          />
          { erro && <p className="text-red-400 text-sm">{ erro }</p> }
          <Button onClick={ handleLogin } variant="contained" fullWidth>
            Entrar
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="bg-gray-900 p-8 rounded-lg w-full max-w-sm flex flex-col gap-4">
        <h1 className="text-white text-xl font-bold text-center">Trocar Link</h1>
        <p className="text-gray-400 text-xs text-center break-all">
          Atual: { linkSite }
        </p>
        <TextField
          label="Novo Link"
          value={ novoLink }
          onChange={ (e) => { setNovoLink(e.target.value); setSucesso(false); } }
          fullWidth
          size="small"
          disabled={ salvando }
          InputLabelProps={{ style: { color: '#aaa' } }}
          InputProps={{ style: { color: '#fff' } }}
          sx={{ '& .MuiOutlinedInput-root fieldset': { borderColor: '#555' } }}
        />
        { erro && <p className="text-red-400 text-sm">{ erro }</p> }
        { sucesso && <p className="text-green-400 text-sm">Link atualizado com sucesso!</p> }
        <Button
          onClick={ handleSalvar }
          variant="contained"
          color="success"
          fullWidth
          disabled={ salvando }
          startIcon={ salvando ? <CircularProgress size={ 16 } color="inherit" /> : null }
        >
          { salvando ? 'Salvando...' : 'Salvar' }
        </Button>
      </div>
    </div>
  );
}
